import React from 'react';
import './LoadingSpinner.css';

export const LoadingSpinner = () => {
  return (
    <div className='loading-spinner-container'>
        <div className='loading-spinner'></div>
    </div>
  )
}
